import { Alert, List } from "@mantine/core";
import { IconAlertTriangle } from "@tabler/icons-react";
import type { AssistantUsageText } from "@/locales/assistant-usage";
import type { UsageMeterDto } from "@/types/ai-assistant-usage";
import { meterTitle, warningMeters } from "./cap.logic";

interface Props {
	meters: UsageMeterDto[];
	warnPercent: number;
	t: AssistantUsageText;
}

/** Banner peringatan ≥ ambang (hanya tampilan admin; tidak memblokir apa pun di C1). */
export function CapWarningBanner({ meters, warnPercent, t }: Props) {
	const hot = warningMeters(meters);
	if (hot.length === 0) return null;
	return (
		<Alert
			color={hot.some((m) => m.level === "full") ? "red" : "yellow"}
			icon={<IconAlertTriangle size={16} />}
			title={t.warnTitle(warnPercent)}
			data-usage-warning
		>
			<List size="sm" spacing={2}>
				{hot.map((m) => (
					<List.Item key={m.id}>
						{m.level === "full"
							? t.fullLine(meterTitle(m, t))
							: t.warnLine(meterTitle(m, t), m.percent ?? 0)}
					</List.Item>
				))}
			</List>
		</Alert>
	);
}
